import { render } from "./SaleCustomersAddModal.vue?vue&type=template&id=5a7a17a0&scoped=true"
import script from "./SaleCustomersAddModal.vue?vue&type=script&lang=js"
export * from "./SaleCustomersAddModal.vue?vue&type=script&lang=js"

import "./SaleCustomersAddModal.vue?vue&type=style&index=0&id=5a7a17a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7a17a0"]])

export default __exports__